<template>
  <ul class="flex color_666 state">
    <li class="mr8 flex0" v-if="info.docPicConsultStatus">
      <div class="flex0">图文</div>
      <span v-if="info.docPicConsultPriceOfSt">{{ info.docPicConsultPriceOfSt }}</span>
    </li>
    <li class="mr8 flex0" v-if="info.docVideoConsultStatus">
      <div class="flex0">视频</div>
      <span v-if="info.docVideoConsultPriceOfSt">{{ info.docVideoConsultPriceOfSt }}</span>
    </li>
    <li class="flex0" v-if="info.teamConsultStatus">
      <div class="flex0">团队</div>
      <span v-if="info.teamConsultPriceOfSt">{{ info.teamConsultPriceOfSt }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "doc-services-v2",
  props: {
    info: {
      type: Object,
      default: () => Object.create(null)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../common/public";

.state {

  li {
    align-items: center;
    display: flex;
    border: 1px solid rgba(47, 131, 255, 0.3);
    border-radius: px2rem(12px);
    padding: px2rem(3px) px2rem(7px) px2rem(2px);

    div {
      color: #666666;
      font-weight: 400;
      font-size: px2rem(14px);
    }

    span {
      margin-left: px2rem(5px);
      color: #2F83FF;
      font-weight: 500;
      font-size: px2rem(14px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/group/components/doc-services-v2.vue